import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {Project} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {ButtonSize, ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {EditSpace} from '@mintdata-wsp/wsp/ui/views/workspace/settings/organization/spaces/EditSpace';
import {SpaceCard} from '@mintdata-wsp/wsp/ui/views/workspace/settings/organization/spaces/SpaceCard';
import {SettingsHeader} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsHeader';
import {SettingsRoutes} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsPanel';
import {SettingsScroll} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsScroll';
import {SettingsSpinner} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsSpinner';
import * as classnames from 'classnames/bind';
import {action, computed, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./OrgSpacesView.less');
const cx = classnames.bind(styles);

@observer
export class OrgSpacesView extends React.Component<RouteComponentProps<any>, any>
{
    @observable
    private _newSpacesIds:number[] = [];

    @computed
    private get _spaces():Project[]
    {
        return rootState.data.projects;
    };

    @observable
    private _viewNewSpace:boolean = false;

    componentDidMount()
    {
        this._initSpacesList();
    }

    @action.bound
    private _initSpacesList()
    {
        controllers.data.projects.syncAllProjects().then(() =>
        {
            controllers.analytics.main.trackEvent(AnalyticsEventActions.WSP_PAGE_LOADED);
        });
    }

    @action.bound
    _buttonAddSpace()
    {
        this._viewNewSpace = true;
    }

    @action.bound
    _buttonCreateSpace(newName:string)
    {
        if( !newName || newName.trim().length === 0 ) return;

        controllers.data.projects
            .createProject(newName.trim(), '')
            .then(action((newSpace:Project) =>
            {
                const {currentOrganization} = rootState.userSession;

                controllers.analytics.main.trackEvent(
                    AnalyticsEventActions.WSP_SPACE_CREATED,
                    {
                        org_sid: currentOrganization.siteId,
                        org_name: currentOrganization.name,

                        space_id: newSpace.id,
                        space_name: newSpace.name
                    }
                );

                this._newSpacesIds.push(newSpace.id);
                this._resetNewState(newSpace);

                this._viewNewSpace = false;

            }))
            .catch((response:ApiError) =>
            {
                if( response.message )
                    throw(response.message);
            });
    }

    @action.bound
    private _resetNewState(space)
    {
        setTimeout(action(() =>
        {
            const index = this._newSpacesIds.indexOf(space.id);
            this._newSpacesIds.splice(index, 1);
        }), 2000);
    }

    @action.bound
    private _buttonCloseCreateSpace()
    {
        this._viewNewSpace = false;
    }

    render()
    {
        return (
            <Column className={cx('spacesSpanIn')}>

                <SettingsHeader
                    className={cx('spacesHeader')}
                    text={'Spaces'}
                    selectedRoute={SettingsRoutes.Spaces}
                >

                    <WSPButton
                        caption={'Add Space'}
                        style={ButtonStyle.Simple}
                        size={ButtonSize.Medium}
                        onClick={this._buttonAddSpace}
                        isDisabled={this._viewNewSpace}
                        className={styles.addBtn}
                    />

                </SettingsHeader>

                {this._viewNewSpace && (
                    <EditSpace
                        onCreate={this._buttonCreateSpace}
                        onClose={this._buttonCloseCreateSpace}
                        buttonTitle={'Create'}
                        isNew={true}
                    />
                )}

                <SettingsScroll>

                    {this._spaces.map((space:Project, index) =>
                    {
                        return (
                            <SpaceCard
                                space={space}
                                key={space.id}
                                isNew={this._newSpacesIds.indexOf(space.id) !== -1}
                            />
                        );
                    })}

                    <SettingsSpinner isVisible={!this._spaces.length} />

                </SettingsScroll>

            </Column>
        );
    }
}





